export default __webpack_public_path__ + "img/codehat-v@3x.c0cdd68b.png";